<template>
    <app-cmp-tabs default="content" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="content" :handle-click="toggle" :active="active">
                <i class="fal fa-file-alt"></i>Content
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <i class="fal fa-th-large"></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <i class="fal fa-pencil-alt"></i>Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="content" :active="active">
                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Properties
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Title
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="title"
                            placeholder=""
                            v-model="element.object.values.title"
                        />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Telephone
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="telephone"
                            placeholder=""
                            v-model="element.object.values.telephone"
                        />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Email address
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="email"
                            placeholder=""
                            v-model="element.object.values.email"
                        />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Live Chat (Description)
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="email"
                            placeholder=""
                            v-model="element.object.values.live_chat"
                        />
                    </div>
                </div>
            </app-cmp-tabs-content>

            <app-cmp-tabs-content name="content" :active="active">
                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Telephones
                </div>

                <app-draggable :list="element.object.values.telephones" class="p-4" :options="{draggable:'.draggable', handle:'.draggable'}" v-if="element.object.values.telephones && element.object.values.telephones.length > 0">
                    <app-collapseable-box
                        v-for="(tel, index) in element.object.values.telephones"
                        class="draggable mb-4 cursor-pointer"
                        :key="index"
                        :index="index"
                        @remove="removeTelephone"
                    >
                        <div slot="header" class="flex items-center justify-between">
                            <div>
                                <h4 v-html="`${(index+1)}: ${tel.name}`" />
                            </div>
                            <div v-if="removeable" class="cursor-pointer z-20 p-1" @click="removeTelephone(index)">
                                <app-icon icon="times" class="text-red text-sm" />
                            </div>
                        </div>

                        <app-field-text
                            label="Name"
                            v-model="element.object.values.telephones[index].name"
                        />

                        <app-field-text
                            label="Number"
                            v-model="element.object.values.telephones[index].number"
                        />
                    </app-collapseable-box>
                </app-draggable>
                <p v-else class="p-4 text-sm">
                    There are currently no telephone numbers in the array.
                </p>

                <div class="px-4 text-right w-full">
                    <app-button element="a" class="btn  btn--primary  btn--primary--sml mb-4" @click="addTelephone">
                        Add
                    </app-button>
                </div>
            </app-cmp-tabs-content>

            <app-cmp-tabs-content name="content" :active="active">
                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Button
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Link
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="title"
                            placeholder=""
                            v-model="element.object.values.button_link"
                        />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Text
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="telephone"
                            placeholder=""
                            v-model="element.object.values.button_text"
                        />
                    </div>
                </div>
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="content" :active="active">
                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    FAQs
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Title
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="title"
                            placeholder=""
                            v-model="element.object.values.faqs_title"
                        />
                    </div>
                </div>

                <app-draggable :list="element.object.values.items" class="p-4" :options="{draggable:'.draggable', handle:'.draggable'}" v-if="element.object.values.items.length > 0">
                    <app-collapseable-box
                        v-for="(item, index) in element.object.values.items"
                        class="draggable mb-4 cursor-pointer"
                        :key="index"
                        :index="index"
                        @remove="remove"
                    >
                        <div slot="header" class="flex items-center justify-between">
                            <div>
                                <h4 v-html="`FAQ ${(index + 1)} `" />
                            </div>
                            <div v-if="removeable" class="cursor-pointer z-20 p-1" @click="remove(index)">
                                <app-icon icon="times" class="text-red text-sm" />
                            </div>
                        </div>

                        <app-field-text
                            label="Question"
                            v-model="element.object.values.items[index].question"
                        />

                        <app-field-text
                            label="Highlighted text"
                            v-model="element.object.values.items[index].question_highlight"
                        />

                        <app-cmp-trix-field
                            label="Answer"
                            :classes="{ wrapper: { 'reset': true } }"
                            v-model="element.object.values.items[index].answer"
                        />
                    </app-collapseable-box>
                </app-draggable>
                <p v-else class="p-4 text-sm">
                    There are currently no breadcrumb links.
                </p>

                <div class="px-4 text-right w-full">
                    <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="add">
                        Add
                    </app-button>
                </div>
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';
    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';

    import Button from '@/components/Button';
    import CollapseableBox from '@/components/CollapseableBox';
    import TextField from '@/components/fields/inputs/Text';
    import SelectField from '@/components/fields/inputs/Select';
    import ComposerTrixField from '@/components/composer/Fields/Trix';

    import draggable from 'vuedraggable';

    import GlobalField from '@/components/composer/Fields/Global';
    import GlobalMixin from '@/components/composer/Mixins/Global';

    export default {
        components: {
            'app-draggable': draggable,
            'app-button': Button,
            'app-collapseable-box': CollapseableBox,
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
            'app-field-text': TextField,
            'app-field-select': SelectField,
            'app-cmp-trix-field': ComposerTrixField,
            'app-global-element': GlobalField
        },

        mixins: [ GlobalMixin ],

        props: {
            element: {
                type: Object,
                required: true
            },
            locale: {
                required: false
            },
            removeable: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        data: () => ({
            fields: {
                question: {
                    name: 'Question',
                    attribute: 'question'
                },
                question_highlight: {
                    name: 'Question highlight',
                    attribute: 'question_highlight'
                },
                answer: {
                    name: 'Answer',
                    attribute: 'answer'
                },
            },
        }),

        methods: {
            add() {
                this.element.object.values.items.push({
                    'question': '',
                    'question_highlight': '',
                    'answer': ''
                });
            },

            remove(index) {
                this.element.object.values.items.splice(index, 1);
            },

            addTelephone() {
              if (this.element.object.values.telephones) {
                this.element.object.values.telephones.push({
                    'name': '',
                    'number': ''
                });
              } else {
                this.$set(this.element.object.values, 'telephones', [{
                    'name': '',
                    'number': ''
                }]);
              }
            },

            removeTelephone(index) {
                this.element.object.values.telephones.splice(index, 1);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Elements/ContactUsHeaderSettings.vue